(function () {
    'use strict';

    angular
        .module('autoRosterSchedule')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('autoRosterSchedule', {
                url: '/auto-roster-schedule',
                views: {
                    'autoRosterScheduleView': {
                        templateUrl: 'auto-roster-schedule/views/auto-roster-schedule.tpl.html',
                        controller: 'AutoRosterScheduleCtrl',
                        controllerAs: 'autoRosterSchedule'
                    }
                }
            });
    }
}());
